export default __webpack_public_path__ + "ec519fb546ce691801c622d584aa2b02.svg";